import angular from 'angular';
import uiRouter from 'angular-ui-router';
import dynamicLinkEditFormComponent from './dynamicLinkEditForm.component';

let dynamicLinkEditFormModule = angular.module('dynamicLinkEditForm', [
  uiRouter
])

.component('dynamicLinkEditForm', dynamicLinkEditFormComponent)

.name;

export default dynamicLinkEditFormModule;
